export type AnyRow = Record<string, unknown>;

/** Ссылка на другой справочник: `{ id, nameRu, nameKy }` под каким-то именем поля. */
export type RefValue = {
  id: number | null;
  nameRu: string | null;
  nameKy: string | null;
  fieldKey: string;
};

/** Приводит найденное поле-ссылку к `RefValue`. Пустую ссылку считает отсутствующей. */
export function normalizeRef(
  row: AnyRow,
  fieldKey: string | null,
): RefValue | null {
  if (!fieldKey) return null;

  const value = row?.[fieldKey] as Record<string, unknown> | null | undefined;
  if (!value || typeof value !== "object") return null;

  const id = (value.id as number) ?? null;
  const nameRu = (value.nameRu as string) ?? null;
  const nameKy = (value.nameKy as string) ?? null;

  if (id === null && !nameRu && !nameKy) return null;

  return { id, nameRu, nameKy, fieldKey };
}

/**
 * Как `normalizeRef`, но для полей, которые есть у справочника всегда, даже когда
 * значение не заполнено (`unitMeasurement`). Возвращает пустую ссылку, а не `null`.
 */
export function normalizeOptionalRef(
  row: AnyRow,
  fieldKey: string | null,
): RefValue | null {
  if (!fieldKey) return null;
  return (
    normalizeRef(row, fieldKey) ?? {
      id: null,
      nameRu: null,
      nameKy: null,
      fieldKey,
    }
  );
}
